import { serverOnly$ } from 'vite-env-only/macros';

import deTranslation from '~/config/locales/de';
import frTranslation from '~/config/locales/fr';
import itTranslation from '~/config/locales/it';

// This is the list of languages your application supports, the last one is your
// fallback language
export const supportedLngs = ['de', 'fr', 'it'];

// This is the language you want to use in case
// the user language is not in the supportedLngs
export const fallbackLng = 'de';

// The default namespace of i18next is "translation", but you can customize it
export const defaultNS = 'translation';

export const resources = serverOnly$({
  de: { translation: deTranslation },
  fr: { translation: frTranslation },
  it: { translation: itTranslation }
});
